<template>
    <div class="u-padding-narrow u-full-height" dusk="partner-order-overview-component">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <single-service-overview
                    :domain="{ domain: domain }"
                    :orderedService="orderedService"
                    :orderTotalPrice="orderTotalPrice"
                    :productType="productType"
                />
            </div>
        </div>

        <div class="wizard-footer">
            <span class="u-margin-bottom-responsive">
                <small v-html="trans('order.support')"></small>
            </span>
            <div>
                <customer-router-link :to="{ name: 'orderHostingSelect' }">
                    <div class="button-back-wrapper">
                        <button type="button" class="btn btn--back">
                            {{ trans('order.hosting') }}
                        </button>
                    </div>
                </customer-router-link>
                <button :disabled="loading" type="button" class="btn btn--blue btn--nav" @click="submitOrder">
                    {{ trans('order.order') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from 'relapp-event';
import { SingleServiceOverview, singleServiceMixin, orderPageMixin } from 'relapp-register';
import { ServersApi } from 'relapp-servers';

export default {
    components: {
        SingleServiceOverview
    },
    mixins: [singleServiceMixin, orderPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'hosting'
        };
    },
    metaInfo: {
        title: trans('page.order.overview')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServers();
    },
    methods: {
        /**
         * Get the servers.
         */
        getServers() {
            ServersApi.get().then(this.finishLoading);
        },
        /**
         * Submit the order to the backend.
         */
        submitOrder() {
            this.startLoading();
            this.sendOrder()
                .then(result => {
                    this.$router.push({ name: 'hostingOverview', params: { domain: this.domain } });
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.saved')
                    });
                    // this is done asynchronously so the tracking has no effect on the completion of an order.
                    Promise.resolve().then(() => {
                        this.trackPlacedOrder(result.transactionId, result.productsOrdered.subscriptions);
                    });
                })
                .catch(error => {
                    this.showValidationNotification(error, trans('message.error.order'));
                })
                .then(this.finishLoading);
        }
    }
};
</script>
